if (!customElements.get('misa-search')) {
  customElements.define('misa-search', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      this.input = this.querySelector('[data-predictive-input]');
      this.results = this.querySelector('[data-predictive-container]');
      this.status = this.querySelector('[data-search-status]');
      this.all = this.querySelector('[data-search-all]');
      this.form = this.querySelector('form');
      const options = {signal:this.events.signal};
      this.input.addEventListener('input', event => { if (!event.isComposing) this.schedule(); }, options);
      this.input.addEventListener('compositionend', () => this.schedule(), options);
      this.input.addEventListener('focus', () => { if (this.input.value.trim()) this.schedule(); }, options);
      this.input.addEventListener('keydown', event => this.onKey(event), options);
      this.all.addEventListener('click', () => this.form.requestSubmit(), options);
      this.closest('dialog').addEventListener('close', () => this.cancel(), options);
      this.activeIndex = -1;
    }
    disconnectedCallback() { this.cancel(); this.events?.abort(); }
    cancel() { clearTimeout(this.timer); this.request?.abort(); }
    schedule() {
      this.cancel();
      this.activeIndex = -1;
      this.input.removeAttribute('aria-activedescendant');
      this.input.setAttribute('aria-expanded', 'false');
      this.results.hidden = true;
      this.results.replaceChildren();
      this.results.removeAttribute('aria-busy');
      const query = this.input.value.trim();
      this.querySelectorAll('[data-search-start]').forEach(node => node.hidden = !!query);
      this.all.hidden = !query;
      this.status.textContent = '';
      if (query) this.timer = setTimeout(() => this.suggest(query), 200);
    }
    async suggest(query) {
      const request = new AbortController();
      this.request = request;
      this.status.textContent = this.dataset.loading;
      this.results.setAttribute('aria-busy', 'true');
      const timeout = setTimeout(() => request.abort(), 10000);
      try {
        const url = new URL(this.dataset.endpoint, location.origin);
        url.search = new URLSearchParams({q:query, 'resources[type]':'product', 'resources[limit]':'4', 'resources[options][unavailable_products]':'last', 'resources[options][fields]':'title,product_type,variants.title,variants.sku,body', section_id:'predictive-search'}).toString();
        const response = await fetch(url, {signal:request.signal, credentials:'same-origin'});
        if (!response.ok) throw new Error(`Search HTTP ${response.status}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fragment = doc.querySelector('[data-predictive-fragment]');
        if (!fragment) throw new Error('Missing predictive results');
        if (this.request !== request || query !== this.input.value.trim() || request.signal.aborted) return;
        this.results.append(...fragment.children);
        this.results.querySelectorAll('a').forEach(link => link.tabIndex = -1);
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', String(!!this.results.querySelector('[role="option"]')));
        this.status.textContent = fragment.dataset.message;
      } catch (error) {
        if (this.request === request && query === this.input.value.trim() && this.closest('dialog').open) this.status.textContent = this.dataset.error;
      } finally {
        clearTimeout(timeout);
        if (this.request === request) this.results.removeAttribute('aria-busy');
      }
    }
    onKey(event) {
      if (event.isComposing) return;
      const options = [...this.results.querySelectorAll('[role="option"]')];
      if (event.key === 'Escape' && this.input.getAttribute('aria-expanded') === 'true') {
        event.preventDefault();
        this.cancel();
        this.results.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
        this.activeIndex = -1;
        return;
      }
      if (!options.length || this.results.hidden) return;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        this.activeIndex = this.activeIndex < 0 ? (event.key === 'ArrowDown' ? 0 : options.length - 1) : (this.activeIndex + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
        options.forEach((option, index) => option.setAttribute('aria-selected', String(index === this.activeIndex)));
        const selected = options[this.activeIndex];
        this.input.setAttribute('aria-activedescendant', selected.id);
        selected.scrollIntoView({block:'nearest'});
      } else if (event.key === 'Enter' && this.activeIndex >= 0) {
        event.preventDefault();
        options[this.activeIndex].querySelector('a')?.click();
      }
    }
  });
}
